// ユーザーIDを取得する
export function getUserId() {
  // ローカルストレージから取得
  let userId = localStorage.getItem('userId');
  if (!userId) {
    // 取得できない場合は新規生成
    userId = Math.random().toString(36).substr(2, 9);
    localStorage.setItem('userId', userId);
  }
  return userId;
}
